"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genRgbppLaunchCkbVirtualTx = void 0;
const error_1 = require("../error");
const utils_1 = require("../utils");
const rgbpp_1 = require("../utils/rgbpp");
const constants_1 = require("../constants");
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
/**
 * Generate the virtual ckb transaction for the btc transfer tx
 * @param collector The collector that collects CKB live cells and transactions
 * @param ownerRgbppLockArgs The owner RGBPP lock args whose data structure is: out_index | bitcoin_tx_id
 * @param launchAmount The total amount of RGBPP assets issued
 * @param rgbppTokenInfo The RGBPP token info https://github.com/ckb-cell/unique-cell?tab=readme-ov-file#xudt-information
 * @param isMainnet True is for BTC and CKB Mainnet, false is for BTC and CKB Testnet(see btcTestnetType for details about BTC Testnet)
 * @param witnessLockPlaceholderSize(Optional) The WitnessArgs.lock placeholder bytes array size and the default value is 5000
 * @param ckbFeeRate(Optional) The CKB transaction fee rate, default value is 1100
 * @param btcTestnetType(Optional) The Bitcoin Testnet type including Testnet3 and Signet, default value is Testnet3
 */
const genRgbppLaunchCkbVirtualTx = (_a) => __awaiter(void 0, [_a], void 0, function* ({ collector, ownerRgbppLockArgs, launchAmount, rgbppTokenInfo, witnessLockPlaceholderSize, ckbFeeRate, isMainnet, btcTestnetType, }) {
    const ownerLock = (0, rgbpp_1.genRgbppLockScript)(ownerRgbppLockArgs, isMainnet, btcTestnetType);
    let emptyCells = yield collector.getCells({ lock: ownerLock });
    if (!emptyCells || emptyCells.length === 0) {
        throw new error_1.NoLiveCellError('The owner address has no empty cells');
    }
    emptyCells = emptyCells.filter((cell) => !cell.output.type);
    const infoCellCapacity = (0, utils_1.calculateRgbppTokenInfoCellCapacity)(rgbppTokenInfo, isMainnet);
    const txFee = constants_1.MAX_FEE;
    const { inputs, sumInputsCapacity } = collector.collectInputs(emptyCells, infoCellCapacity, txFee);
    let rgbppCellCapacity = sumInputsCapacity - infoCellCapacity;
    const outputs = [
        {
            lock: (0, rgbpp_1.genRgbppLockScript)((0, rgbpp_1.buildPreLockArgs)(1), isMainnet, btcTestnetType),
            type: Object.assign(Object.assign({}, (0, constants_1.getXudtTypeScript)(isMainnet)), { args: (0, utils_1.append0x)((0, ckb_sdk_utils_1.scriptToHash)(ownerLock)) }),
            capacity: (0, utils_1.append0x)(rgbppCellCapacity.toString(16)),
        },
        {
            lock: (0, rgbpp_1.genBtcTimeLockScript)(constants_1.UNLOCKABLE_LOCK_SCRIPT, isMainnet, btcTestnetType),
            type: Object.assign(Object.assign({}, (0, constants_1.getUniqueTypeScript)(isMainnet)), { args: (0, utils_1.generateUniqueTypeArgs)(inputs[0], 1) }),
            capacity: (0, utils_1.append0x)(infoCellCapacity.toString(16)),
        },
    ];
    const outputsData = [(0, utils_1.append0x)((0, utils_1.u128ToLe)(launchAmount)), (0, rgbpp_1.encodeRgbppTokenInfo)(rgbppTokenInfo)];
    const cellDeps = yield (0, utils_1.fetchTypeIdCellDeps)(isMainnet, { rgbpp: true, xudt: true, unique: true }, btcTestnetType);
    const witnesses = inputs.map((_, index) => (index === 0 ? constants_1.RGBPP_WITNESS_PLACEHOLDER : '0x'));
    const ckbRawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(ckbRawTx) + (witnessLockPlaceholderSize !== null && witnessLockPlaceholderSize !== void 0 ? witnessLockPlaceholderSize : constants_1.RGBPP_TX_WITNESS_MAX_SIZE);
    const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize, ckbFeeRate);
    rgbppCellCapacity -= estimatedTxFee;
    ckbRawTx.outputs[0].capacity = (0, utils_1.append0x)(rgbppCellCapacity.toString(16));
    const virtualTx = Object.assign(Object.assign({}, ckbRawTx), { outputs: ckbRawTx.outputs });
    const commitment = (0, rgbpp_1.calculateCommitment)(virtualTx);
    return {
        ckbRawTx,
        commitment,
        needPaymasterCell: false,
    };
});
exports.genRgbppLaunchCkbVirtualTx = genRgbppLaunchCkbVirtualTx;
